module.exports = __webpack_public_path__ + "img/object_three.a9ebf4db.png";